export default "https://assets.egbcdn.net/assets/packs/_/images/app/app-native-540b7f64a775f1579d18c5009c638536.png";